<template>
  <div v-if="methodId" class="grid-container grid-container__last-chance">
    <div class="buy-credits__timer">
      <div class="timer__time">{{ trans.get('ms:shop.lc_package.time_left') }} <span>{{ timer }}</span></div>
      <div class="timer__promotion">{{ trans.get('ms:shop.lc_package.header') }}<span>!</span></div>
      <div class="timer__promotion-desc">{{ trans.get('ms:shop.lc_package.slogan') }}</div>
    </div>

    <div class="buy-credits__payment">

      <div class="payment-wrapper">
        <label v-for="method in methods.slice(0, 4)">
          <input v-model="methodId" name="payment_method" type="radio" class="radio__icon" :value="method.id">
          <a
            v-show="method.id !== methodId"
            class="button button__icon-flex button__icon-image not-active-method"
            :title="method.name"
            v-html="method.image_inactive"
          >
          </a>
          <a
            v-show="method.id === methodId"
            class="button button__icon-flex button__icon-image active-method"
            :title="method.name"
            v-html="method.image"
          >
          </a>
        </label>
      </div>
    </div>

    <template v-if="shopPackage && currentMethod">
      <transition name="fade">
        <PackageElement
          :key="shopPackage.id"
          :shopPackage="shopPackage"
          :fee="currentMethod.fee"
          @price="price = arguments[0]"
          @buy="buy"
          :voucher="null"
        >
        </PackageElement>
      </transition>
    </template>

    <div v-if="shopPackage && currentMethod" class="buy-credits__button">
      <button class="button button--primary" @click="buy( {package_id: shopPackage.id})">
        {{ trans.get('ms:shop.buy_now_button') }}
      </button>
    </div>
    <div class="buy-credits__price">
      {{ price }} &euro;
    </div>
  </div>
</template>

<script>
import PackageElement from './PackageElement';
import Voucher from './Voucher';

export default {
  name: 'LastChanceComponent',
  components: { Voucher, PackageElement },
  props: {
    unit: {
      type: String,
      required: true,
      validator: function (value) {
        return ['coin', 'joker'].indexOf(value) !== -1;
      }
    },
    timeout: {
      type: Number | String,
      required: false,
      default: 3600,
    },
  },
  data() {
    return {
      shopPackage: null,
      price: null,
      methods: [],
      methodId: null,
      gUnit: {
        coin: window.globals.customer_shop_package.unit_coin,
        joker: window.globals.customer_shop_package.unit_joker,
      },
      timer: '',
    };
  },
  computed: {
    currentMethod: function () {
      if (this.methodId) {
        return this.methods.find((el) => el.id === this.methodId);
      }
      return null;
    },
    customerShopPackages: function () {
      if (this.currentMethod) {
        return this.currentMethod.customer_shop_packages;
      }
      return [];
    },
  },
  watch: {},
  methods: {
    fetchPackage: function () {
      return axios.get(zRoute('ajax.payment.last_chance', {
        unit: this.unit,
        service: 'WEB',
        type: 'SHOP_EXIT',
      }))
        .then((response) => {
          if (response.data.data && response.data.data.payment_methods) {
            this.shopPackage = response.data.data;
            this.methods = response.data.data.payment_methods;
            this.methodId = this.methods[0].id;
          }
        });
    },
    buy: function ({ package_id }) {
      axios.post(zRoute('ajax.payment.store'), {
        customer_shop_package_id: package_id,
        price: this.price,
        payment_method_id: this.methodId,
        voucher_id: null,
      }).then((response) => {
        window.location.href = response.data.redirect_url;
      });
    },
    redirectToPayments: function () {
      let vm = this;

      if (vm.unit === 'coin') {
        this.$router.replace({ name: 'payment', params: { unit: 'credits' } });
        // window.location.href = zRoute('front.more_settings.payment', 'credits');
      } else if (vm.unit === 'joker') {
        this.$router.push({ name: 'payment', params: { unit: 'jokers' } });
        // window.location.href = zRoute('front.more_settings.payment', 'jokers');
      } else {
        window.location.href = zRoute('home');
      }
    },
  },
  mounted() {
    let vm = this;
    this.fetchPackage()
      .then(() => {
        if (!this.methodId) {
          vm.redirectToPayments();
          return;
        }

        // Set the date we're counting down to
        const countDownDate = (new Date().getTime()) + (1000 * vm.timeout);

        // Update the count down every 1 second
        let x = setInterval(function () {

          // Get today's date and time
          let now = new Date().getTime();

          // Find the distance between now and the count down date
          const distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Display the result in the element with id="demo"
          vm.timer = minutes + 'm ' + seconds + 's ';

          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            vm.redirectToPayments();
          }
        }, 1000);
      });
  }
};
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
